module.exports = __webpack_public_path__ + "img/logo-presse-jdn_200x200.fc7e6cc8.png";